var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTwotoneEuro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89156 13.4648C8.15063 13.4655 7.4238 13.2653 6.79061 12.8863C6.15742 12.5072 5.64226 11.9639 5.30153 11.3157H8.89156L9.51483 10.0876H4.89017C4.85901 9.88499 4.84031 9.68236 4.84031 9.47358C4.84031 9.26481 4.85901 9.06218 4.89017 8.85955H8.89156L9.51483 7.63148H5.30153C5.64281 6.98374 6.15809 6.44077 6.79116 6.06179C7.42423 5.68281 8.15078 5.48238 8.89156 5.48236C9.89502 5.48236 10.8175 5.84464 11.528 6.44639L12.6312 5.35955C11.6047 4.44947 10.2725 3.94633 8.89156 3.94727C6.44834 3.94727 4.37909 5.4885 3.60624 7.63148H1.41233L0.789062 8.85955H3.31953C3.26929 9.26741 3.26929 9.67976 3.31953 10.0876H1.41233L0.789062 11.3157H3.60624C4.37909 13.4587 6.44834 14.9999 8.89156 14.9999C10.3313 14.9999 11.6402 14.4657 12.6312 13.5876L11.5218 12.5008C10.8175 13.1025 9.90125 13.4648 8.89156 13.4648Z",
    fill: "#253837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 9.47389H15.7896M13.4212 11.8423V7.10547",
    stroke: "#253837",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwotoneEuro2);
export default __webpack_public_path__ + "static/media/ic_twotone-euro2.0533bf6fdf331693208256f4061b36f0.svg";
export { ForwardRef as ReactComponent };